import React, { useEffect, useState } from 'react';
import { Users, UserCheck, DollarSign, ClipboardCheck, Radar, CreditCard } from 'lucide-react';
import { adminApi } from '../../lib/adminApi';
import { ADMIN_OVERVIEW } from '../../constants/testIds';

const StatCard = ({ icon: Icon, label, value, testId, accent }) => (
  <div data-testid={testId} className="bg-white rounded-2xl border border-stone-200 p-5 flex items-start gap-4">
    <span className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${accent}`}>
      <Icon size={20} className="text-white" strokeWidth={2.2} />
    </span>
    <div>
      <p className="text-2xl font-extrabold text-stone-900 leading-none">{value}</p>
      <p className="text-sm text-stone-500 mt-1.5">{label}</p>
    </div>
  </div>
);

const AdminOverview = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get('/admin/overview').then(({ data }) => setStats(data)).catch(() => setStats(null));
  }, []);

  return (
    <div data-testid={ADMIN_OVERVIEW.page}>
      <h1 className="text-2xl font-extrabold text-stone-900 mb-1">Overview</h1>
      <p className="text-stone-500 text-sm mb-7">Snapshot of your Ambanji business.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <StatCard icon={Users} label="Total clients" value={stats?.total_clients ?? '—'} testId={ADMIN_OVERVIEW.statTotalClients} accent="bg-[#4F46E5]" />
        <StatCard icon={UserCheck} label="Active clients" value={stats?.active_clients ?? '—'} testId={ADMIN_OVERVIEW.statActiveClients} accent="bg-[#F97316]" />
        <StatCard icon={DollarSign} label="MRR estimate" value={stats ? `$${stats.mrr_estimate.toLocaleString()}` : '—'} testId={ADMIN_OVERVIEW.statMrr} accent="bg-emerald-600" />
        <StatCard icon={ClipboardCheck} label="Pending approvals" value={stats?.pending_approvals ?? '—'} testId={ADMIN_OVERVIEW.statPendingApprovals} accent="bg-amber-500" />
        <StatCard icon={Radar} label="Total audits run" value={stats?.total_audits ?? '—'} testId={ADMIN_OVERVIEW.statTotalAudits} accent="bg-stone-700" />
        <StatCard icon={CreditCard} label="Paid subscriptions" value={stats?.paid_subscriptions ?? '—'} testId={ADMIN_OVERVIEW.statPaidSubscriptions} accent="bg-indigo-800" />
      </div>
    </div>
  );
};

export default AdminOverview;
